export const CHATCENTER_AVAILABLE_COUNTRIES_ID = [
  52, 135, 158, 199, 157, 6, 161, 137, 49,
];

export const CHAT_PHONES = {
  sales: "5491122799115",
  chatcenter: "5491135612201",
  brasil: "5548988632105",
};

export const APPS_NOT_ALLOWED = [
  "mi-voucher",
  "assist-pay",
  "checkout",
  "requisitos",
  "tramites",
  "viajes",
  "destinos",
  "afiliados",
  "dicas-de-viagem-argentina-2023",
  "informacoes-de-viagem-para-o-uruguai-2023",
];

// Convertido de Array a Set para mejor rendimiento O(1)
export const PRE_SALES_AVAILABLE_COUNTRIES = new Set(["ar", "cl"]);

// Configuración de horarios de atención
export const CHAT_HOURS = {
  SALES_START: "02:00",
  SALES_END: "20:00",
};